// extracted by mini-css-extract-plugin
export var center = "ParagraphSection-module--center--37666";
export var inline = "ParagraphSection-module--inline--17715";
export var insurance = "ParagraphSection-module--insurance--c49ea";
export var list = "ParagraphSection-module--list--ccac4";
export var mobileCentered = "ParagraphSection-module--mobileCentered--57695";
export var paragraph = "ParagraphSection-module--paragraph--93eec";
export var paragraphContent = "ParagraphSection-module--paragraphContent--abd94";
export var paragraphTitle = "ParagraphSection-module--paragraphTitle--a3e8f";
export var primary = "ParagraphSection-module--primary--da635";
export var right = "ParagraphSection-module--right--66514";
export var section = "ParagraphSection-module--section--79edd";
export var sectionContent = "ParagraphSection-module--sectionContent--67e1f";
export var sectionFooter = "ParagraphSection-module--sectionFooter--31562";
export var sectionTitle = "ParagraphSection-module--sectionTitle--342af";
export var wedding = "ParagraphSection-module--wedding--b1bf1";